import { defineStore } from 'pinia';
import axios from 'axios';

export const useAuthStore = defineStore('auth', {
    state: () => ({
        accessToken: null,
        userProfile: null,
        authInitialized: false,
        authLoading: false,
    }),

    getters: {
        isAuthenticated: (state) => !!state.accessToken,
        isReady: (state) => state.authInitialized
    },

    actions: {
        login(accessToken, userProfile) {
            this.accessToken = accessToken;
            this.userProfile = userProfile;
            this.authInitialized = true;
        },

        setAccessToken(accessToken) {
            this.accessToken = accessToken;
        },

        setUserProfile(userProfile) {
            this.userProfile = userProfile;
        },

        setAuthInitialized(value = true) {
            this.authInitialized = value;
        },

        async fetchUserProfile() {
            try {
                const res = await axios.get(
                    `${process.env.VUE_APP_API_BASE_URL}/auth/profile/`,
                    {
                        withCredentials: true,
                        headers: {
                            Authorization: this.accessToken
                                ? `Bearer ${this.accessToken}`
                                : undefined,
                        },
                    }
                );

                console.log(res)

                this.userProfile = res.data;
                return res.data;
            } catch (err) {
                console.error("Failed to fetch profile:", err);
                throw err;
            }
        },


        async refreshAccessToken() {
            const response = await axios.post(
                `${process.env.VUE_APP_API_BASE_URL}/auth/login/refresh/`,
                {},
                {
                    withCredentials: true,
                }
            );

            const accessToken =
                response.data.access ||
                response.data.access_token ||
                response.data.data?.access;

            if(!accessToken){
                throw new Error("No access token returned")
            }

            this.accessToken = accessToken;

            // Optional:
            // If your refresh endpoint returns user data
            // if (response.data.user) {
            //     this.userProfile = response.data.user;
            // }
            // ALWAYS refresh profile after token refresh
            this.fetchUserProfile().catch(err => {
            console.warn("Profile load failed (non-blocking):", err);
        });

            return accessToken;
        },

        async initializeAuth() {
             if (this.authInitialized || this.authLoading) return;

                    this.authLoading = true;

            try {
                await this.refreshAccessToken();
            } catch (error) {
                console.error("Auth init failed:", error);
                this.logout();
            } finally {
                this.authInitialized = true;
                this.authLoading = false;
            }
        },

        logout() {
            this.accessToken = null;
            this.userProfile = null;
            this.authInitialized = true;
        },
    },
});